import type { AvailableRoles } from '@hooks/useAvailableRoles'

import type { Users } from '../Team.types'

export const sortTeamUsers = (
  userEmail?: string,
  users?: Users,
  availableRoles?: AvailableRoles,
) => {
  if (!users || !availableRoles) return []

  return users.sort((userA, userB) => {
    const roleA = availableRoles.find(({ id }) => id === userA.group)
    const roleB = availableRoles.find(({ id }) => id === userB.group)

    if (!roleA || !roleB || roleA === roleB) {
      if (userA.invitationStatus === 'FULFILLED' && userB.invitationStatus !== 'FULFILLED') {
        return -1
      }

      if (userEmail && userA.email === userEmail) {
        return -1
      }

      return 0
    }

    return roleB.permissions.length - roleA.permissions.length
  })
}
